// extracted by mini-css-extract-plugin
export default {"root":"agenda-list_root__OhHIK"};